import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_PRODUCTS_URL || 'https://neoin-enterprise-sku-ewc6b8ewb7heakby.southindia-01.azurewebsites.net';

export const getProductsAPIHelper = async (payload) => {
  try {
    // Get access token from localStorage
    const accessToken = localStorage.getItem('objectId');

    if (!accessToken) {
      throw new Error('Authentication token is missing');
    }

    const response = await axios.get(`${API_BASE_URL}/api/products/`, {
      params: payload, // Spread payload directly if it's an object
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
    });

    return response.data;
  } catch (error) {
    // More detailed error handling
    if (error.response) {
      // Server responded with error status
      throw error.response.data || new Error('Server error');
    } else if (error.request) {
      // Request was made but no response
      throw new Error('Network error - no response from server');
    } else {
      // Something else went wrong
      throw error;
    }
  }
};


export const getSingleProductAPI = async (id) => {

  const accessToken = localStorage.getItem('objectId');

   if (!accessToken) {
      throw new Error('Authentication token is missing');
    }

  console.log("User id Data---", id);
  try {
    const response = await axios.get(`${API_BASE_URL}/api/products/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
    })
    console.log("Get card-----", response);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
}